var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockSizeIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1L0 4v7l7.5 4 7.5-4V4L7.5 1zM7 13.6l-6-3.2V5.533l6 3.2V13.6zM1.297 4.558L7.5 2.077l6.203 2.481L7.5 7.866 1.297 4.558z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockSizeIcon);
export default __webpack_public_path__ + "static/media/block-size-icon.e14a8e897563f46ff1b16a80a1fb0f21.svg";
export { ForwardRef as ReactComponent };